import {VueAutosuggest} from 'vue-autosuggest';
import {find} from 'lodash';

export default {

  components: {
    VueAutosuggest,
  },

  props: {
    refFormUrl: {
      type: String,
      required: true,
    },
    refId: {
      type: String,
      required: true,
    },
    refName: {
      type: [String, Object],
      required: true,
    },
    refOptionKeys: {
      type: Array,
      required: true,
    },
    refPlaceholder: {
      type: String,
      default: '入力・選択してください',
    },
    refSuggestionSelectId: {
      type: String,
      default: 'id',
    },
    refSuggestionSelectName: {
      type: String,
      default: 'name',
    },
  },

  data() {
    return {
      query: '',
    };
  },

  computed: {
    filteredOptions() {
      return [
        {
          data: this.query && _.isArray(this.optionsData) ? this.optionsData.filter(
            (option) => this.refOptionKeys.some(
              (key) => {
                const optionData = (_.get(option, key));
                return optionData
                  ? optionData.toLowerCase().indexOf(this.query.toLowerCase())
                  > -1
                  : false;
              },
            ),
          ) : this.optionsData,
        },
      ];
    },

    matchedOptionId() {
      const matchedOption = find(this.optionsData,
        (option) => this.refOptionKeys.some(
          (key) => {
            const optionData = (_.get(option, key));
            return optionData.toLowerCase() === this.query.toLowerCase()
          }
        )
      );

      return matchedOption ? matchedOption[this.refSuggestionSelectId] : '';
    },
  },

  watch: {
    matchedOptionId(id, oldId) {
      if (id) {
        this.setId(id);
      } else if (oldId) {
        this.setId('')
      }
    }
  },

  methods: {
    /**
     * selectBox選択時の処理
     * @param item
     */
    onSelected(item) {
      this.setQuery(item.item[this.refSuggestionSelectName]);
    },

    /**
     * IDのセット
     * @param value
     */
    setId(value) {
      const data = {[this.refName]: value};
      this.commitAndDispatch(data);
    },

    /**
     * フォーカス時の処理
     */
    onFocus() {
      // フォーカス時にselectの候補を現在選択時のものだけ表示する
      this.setQuery(document.querySelector(`#${this.refId}`).value);
    },

    /**
     * dataをcommit,dispatchする
     * @param data
     */
    commitAndDispatch(data) {
      this.$store.commit('setValue', data);
      this.$store.dispatch('validate', {path: this.refFormUrl, data});
    },

    /**
     * queryのセット
     * @param value
     */
    setQuery(value) {
      this.query = value;
    },
  },
};